import api from './api';

export const listFactories = () => api.get('/factories').then(r => r.data);
export const getFactoryDetail = (factoryId) => api.get(`/factories/${factoryId}`).then(r => r.data);
export const createFactory = (data) => api.post('/factories', data).then(r => r.data);
export const updateFactory = (factoryId, data) => api.put(`/factories/${factoryId}`, data).then(r => r.data);
export const deleteFactory = (factoryId) => api.delete(`/factories/${factoryId}`).then(r => r.data);